import settlements from '@/router/public/settlements'

export default [
  ...settlements,
]
